<template>
  <div>
    <v-card :loading="loading">
      <v-card-text class="px-8 pt-3">
        <div class="d-flex justify-space-between mb-4">
          <v-btn color="primary" :disabled="loading" @click="$emit('rental-modal')" v-if="hasPermission(4096)">
            Adicionar Locação
          </v-btn>
          <v-btn-toggle v-model="filterType" multiple>
            <v-btn value="active" small :color="filterType.includes('active') ? 'success' : undefined" depressed>
              Ativos
            </v-btn>
            <v-btn value="pending" small :color="filterType.includes('pending') ? 'warning' : undefined" depressed>
              Pendentes
            </v-btn>
            <v-btn value="finished" small :color="filterType.includes('finished') ? 'error' : undefined" depressed>
              Finalizados
            </v-btn>
          </v-btn-toggle>
        </div>
        <v-data-table
          :headers="headers"
          :items="filteredRentals"
          :search="search"
          :header-props="{ sortByText: 'Ordenar por:' }"
          :sort-desc="true"
          sort-by="id"
          :items-per-page="itemsPerPage"
          :page="page"
          @update:page="page = $event"
          @update:items-per-page="itemsPerPage = $event"
          hide-default-footer
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              single-line
              hide-details
              filled
              filter
              clearable
            ></v-text-field>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            {{ item.id.slice(0, 8).toUpperCase() }}
          </template>
          <template v-slot:[`item.Clients`]="{ item }">
            <div class="d-flex gap-1">
              <v-chip small>{{ item.Clients[0].client.name }}</v-chip>
              <v-chip v-if="item.Clients.length > 1" small> +{{ item.Clients.length - 1 }} </v-chip>
            </div>
          </template>
          <template v-slot:[`item.Immobiles`]="{ item }">
            <div class="d-flex gap-1">
              <v-chip small>
                {{ item.Immobiles[0].Address.street }}, {{ item.Immobiles[0].Address.number }} -
                {{ item.Immobiles[0].Address.city }}/{{ item.Immobiles[0].Address.state }}
              </v-chip>
              <v-chip v-if="item.Immobiles.length > 1" small> +{{ item.Immobiles.length - 1 }} </v-chip>
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="statusChip[item.status].color" small label>
              {{ statusChip[item.status].text }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <TooltipedBtn
              title="Ver Locação"
              icon
              :to="{ name: 'rental.edit', params: { id: item.id } }"
              v-if="hasPermission(8192)"
            >
              <v-icon>mdi-eye-outline</v-icon>
            </TooltipedBtn>
            <TooltipedBtn
              title="Cancelar Locação"
              @click="deleteItem(item)"
              :disabled="item.status == 'finished'"
              icon
              v-if="hasPermission(16384)"
            >
              <v-icon>mdi-file-cancel-outline</v-icon>
            </TooltipedBtn>
          </template>
          <template v-slot:no-results>
            <v-btn color="primary" @click="search = ''">Resetar</v-btn>
          </template>
          <template v-slot:footer>
            <v-pagination v-model="page" :length="Math.ceil(rentals.length / itemsPerPage)"></v-pagination>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <rental-modal @success="getAll" />
    <rental-delete @success="getAll" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RENTAL from '@/services/rental'
import RentalModal from '@/components/modals/RentalModal.vue'
import RentalDelete from '@/components/modals/RentalDelete.vue'

export default {
  components: { RentalDelete, RentalModal },
  data: () => ({
    loading: false,
    rentals: [],
    search: '',
    page: 1,
    itemsPerPage: 20,
    headers: [
      { text: 'ID Locação', value: 'id', sortable: true, align: 'start' },
      { text: 'Tipo', value: 'type', sortable: true, align: 'center' },
      { text: 'Cliente', value: 'Clients', sortable: true },
      { text: 'Endereço', value: 'Immobiles', sortable: true },
      { text: 'Status', value: 'status', sortable: false, align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'end', width: '120' },
    ],
    filterType: ['active', 'pending'],
    statusChip: {
      active: { text: 'Ativo', color: 'success' },
      pending: { text: 'Pendente', color: 'warning' },
      finished: { text: 'Finalizado', color: 'error' },
    },
  }),

  methods: {
    async getAll() {
      try {
        this.loading = true
        const response = await RENTAL.getAll()
        this.rentals = response.rentals
        this.loading = false
      } catch (e) {
        console.log(e)
        this.$toast.fire({
          icon: 'error',
          title: e.message || 'Erro ao buscar imóveis',
        })
        this.$router.push({ name: 'dashboard' })
      }
    },
    deleteItem(item) {
      this.$emit('rental-delete', item.id)
    },
  },
  computed: {
    ...mapGetters('auth', ['hasPermission']),
    filteredRentals() {
      if (this.filterType.length === 0) return this.rentals
      return this.rentals.filter(rental => this.filterType.includes(rental.status))
    },
  },
  mounted() {
    this.getAll()
  },
}
</script>

<style lang="scss" scoped>
.v-card__title {
  text-align: center !important;
  display: inherit;
}
</style>
